
import React from 'react';
import { Helmet } from 'react-helmet-async';
import SubHeader from '../components/SubHeader';
import ImageGallery from '../components/ImageGallery';

const Gallery = () => {
  const gallerySchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "ERA Interio - Home Interior Ideas",
    "url": "https://www.erainterio.com/gallery",
    "description":
      "Explore home interior ideas for Nagpur homes, including luxury bedrooms, modern modular kitchens and elegant living spaces.",
    "image": "https://www.erainterio.com/images/gallery-3.jpg",
    "telephone": "+91-8830219839",
    "email": "erainterio9@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress":
        "Shop No.2, 1st Floor, Shyama Apartment, Pratap Nagar Square, Pratap Nagar",
      "addressLocality": "Nagpur",
      "addressRegion": "Maharashtra",
      "postalCode": "440022",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 21.1130412,
      "longitude": 79.0561782
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "10:00",
        "closes": "19:00"
      }
    ],
    "sameAs": [
      "https://www.youtube.com/@eraintero",
      "http://www.facebook.com/erainterior9",
      "https://www.instagram.com/erainterio9/"
    ]
  };

  return (
    <>
      <Helmet>
        {/* SEO Title */}
        <title>
          Home Interior Ideas for Nagpur Homes That Look Luxurious | ERA Interio
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Home interior ideas for Nagpur homes that feel personal. Browse bedrooms, kitchens and living rooms, then plan the look you love."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Home Interior Ideas, Luxury Interior Design Nagpur, Bedroom Interior Design, Modular Kitchen Design, Home Interior Design, Home Decoration"
        />

        {/* Robots */}
        <meta
          name="robots"
          content="index, follow, max-image-preview:large"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://www.erainterio.com/gallery"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Home Interior Ideas That Make Every Room Feel Like You"
        />

        <meta
          property="og:description"
          content="Explore stunning home interior ideas, luxury bedrooms and modern modular kitchens. Get inspired to create a space you’ll love."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://www.erainterio.com/gallery"
        />

        <meta
          property="og:image"
          content="https://www.erainterio.com/images/gallery-3.jpg"
        />

        <meta
          property="og:site_name"
          content="ERA Interio"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Home Interior Ideas That Make Every Room Feel Like You"
        />

        <meta
          name="twitter:description"
          content="Explore stunning home interior ideas, luxury bedrooms and modern modular kitchens. Get inspired to create a space you’ll love."
        />

        <meta
          name="twitter:image"
          content="https://www.erainterio.com/images/gallery-3.jpg"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(gallerySchema)}
        </script>
      </Helmet>

      <SubHeader
        seoTitle="Explore Beautiful Home Interior Ideas"
      />

      <ImageGallery />
    </>
  );
};

export default Gallery;
